import Icon from '../components/Icon';

const Pause = Icon(
  'pause',
  <>
    <path d="M7 3.25A1.75 1.75 0 0 0 5.25 5v14c0 .966.784 1.75 1.75 1.75h2A1.75 1.75 0 0 0 10.75 19V5A1.75 1.75 0 0 0 9 3.25zM15 3.25A1.75 1.75 0 0 0 13.25 5v14c0 .966.784 1.75 1.75 1.75h2A1.75 1.75 0 0 0 18.75 19V5A1.75 1.75 0 0 0 17 3.25z" />
  </>
);

export default Pause;
